import api from '../../plugins/api';

// Список марок, настроенных для прямого импорта из Битрикса (appsettings → BITRIX_STOCK)
const getBitrixMarks = () => api.get('/api/crm/cars/bitrixStock/marks');

export default getBitrixMarks;
